
export interface IPNSExecutionResult {
status: string;
}
